import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PlayButton from '../../Buttons/PlayButton/PlayButton';
import RoundedButton from '../../Buttons/RoundedButton/RoundedButton';

import './TrackRow.scss';

import { ReactComponent as RewardsIcon } from '../../../assets/images/reward.svg';

const TrackRow = props => props.track ?
	<li className="track-row">
		<div>
			<h6 className="mr-5 mb-0">{props.track.title}{props.user._id !== props.track.author._id && <><br /><span>{props.track.author.name}</span></>}</h6>
			<PlayButton onClick={props.onPlayClick} />
		</div>
		<div>
			{props.user._id === props.track.author._id || props.user.type !== 'scout' ?
				<>
					<p className="track-points">
						{props.track.points || 0}
						{' punti'}
					</p>
					<p className="track-rewards">
						<RewardsIcon />
						{props.track.rewards ? props.track.rewards.length : 0}
						{' Rewards'}
					</p>
				</> : null}
			{props.user._id !== props.track.author._id || props.user.type !== 'artist' ?
				<RoundedButton color="primary" className="px-3 ml-4 " onClick={() => props.history.push('/users/' + props.track.author._id)}>VISUALIZZA Profilo</RoundedButton>
			:null}
		</div>
	</li>
	: null;

const mapStatetoProps = (state) => {
	return { user: state.Auth.user };
};

export default withRouter(connect(mapStatetoProps, {})(TrackRow));